import type { IAdminTransaction, ITransaction } from "@gen/app-query";

import { TransactionMoney } from "~/entities/transaction";

interface TotalCellProps {
  transactionData: ITransaction | IAdminTransaction;
}

export function TotalCell({ transactionData }: TotalCellProps) {
  return new TransactionMoney(transactionData).getTotal().format();
}
